import(/* webpackMode: "eager", webpackExports: ["BaseAppBar"] */ "/home/braid/braided-hedgedoc/frontend/src/components/layout/app-bar/base-app-bar.tsx");
